var $d07f2857459a2e2e$exports = {};
$d07f2857459a2e2e$exports = {
    "clear": `Not\u{12B}r\u{12B}t`,
    "invalid": `(neder\u{12B}gs)`,
    "loading": `Notiek iel\u{101}de...`,
    "noResults": `Nav rezult\u{101}tu`,
    "valid": `(der\u{12B}gs)`
};


export {$d07f2857459a2e2e$exports as default};
//# sourceMappingURL=lv-LV.mjs.map
